import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import blogBumpModelLaunch from './blogContent/blogBumpModelLaunch';
import blogApiDocsLaunch from './blogContent/blogApiDocsLaunch';
import blogYTandLocalSupport from './blogContent/blogYTandLocalSupport';
import blogZapierSupport from './blogContent/blogZapierSupport';


const blogComponents = {
  'introducing-bump-10-model': blogBumpModelLaunch,
  'api-documentation-now-live': blogApiDocsLaunch,
  'local-and-youtube-video-handling-supported': blogYTandLocalSupport,
  'meet-bumpups-on-zapier': blogZapierSupport,


};

const BlogRender = () => {
  const { slug } = useParams();
  const BlogComponent = blogComponents[slug];

  if (!BlogComponent) {
    return <Navigate to="/" replace />;
  }

  return <BlogComponent />;
};

export default BlogRender;
